import { render, staticRenderFns } from "./add.vue?vue&type=template&id=41ba80e1"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41ba80e1')) {
      api.createRecord('41ba80e1', component.options)
    } else {
      api.reload('41ba80e1', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=41ba80e1", function () {
      api.rerender('41ba80e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/import/general/add.vue"
export default component.exports